import React from 'react';
import { TransformCTA } from '../TransformCTA';
import { bonuses } from '../../data/content';
export function Bonuses() {
  return <section className="w-full bg-ink-950 px-5 py-14 sm:py-20" data-id="element-80" data-mp="1hipsh6t2xlou">
      <div className="mx-auto w-full max-w-xl lg:max-w-5xl" data-id="element-81" data-mp="1cko6ad0cx695">
        <h2 className="text-center font-display text-[26px] font-bold leading-tight text-white sm:text-[34px]" data-id="element-82" data-mp="1citnb48nbo7p">
          🎁 You will also receive these 5 exclusive bonuses
        </h2>
        <div className="mt-5 flex flex-col items-center gap-2" data-id="element-83" data-mp="25925gw36m8ma">
          <span className="text-[13px] font-semibold text-white/55" data-id="element-84" data-mp="20btq139f4ioq">Valued at USD 140</span>
          <span className="rounded-full bg-teal-500 px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.14em] text-ink-950" data-id="element-85" data-mp="1w8dte6xcmic1">
            Included free today
          </span>
        </div>

        <ul className="-mx-5 mt-10 space-y-5 sm:mx-0 lg:grid lg:grid-cols-2 lg:gap-6 lg:space-y-0" data-id="element-86" data-mp="kua072yl4y81">
          {bonuses.map(bonus => <li key={bonus.tag} className="flex flex-col overflow-hidden border-y border-white/10 bg-white/[0.04] sm:rounded-2xl sm:border" data-id="element-87" data-mp="ftm0zu07db2q">
              <div className="w-full bg-white px-2 pb-1 pt-3 sm:px-4 sm:pb-2 sm:pt-4" data-id="element-88" data-mp="1jrgdwr7ybnib">
                <img src={bonus.image} alt={bonus.alt} className="mx-auto block w-full max-w-none" loading="lazy" data-id="element-89" data-mp="15rxc0g5qh8eg" />
              </div>

              <div className="flex flex-1 flex-col p-5 sm:p-6" data-id="element-90" data-mp="w1uhgbiyrme0">
                <span className="w-fit rounded-md bg-teal-500/15 px-2 py-1 text-[10px] font-extrabold uppercase tracking-[0.16em] text-teal-300" data-id="element-91" data-mp="10u5lnqkqlucd">
                  🎁 {bonus.tag}
                </span>
                <h3 className="mt-3 font-display text-[22px] font-bold leading-tight text-white sm:text-[24px]" data-id="element-92" data-mp="r544hx2gh6wt">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-[15px] font-semibold leading-snug text-teal-300" data-id="element-93" data-mp="i3e9kh9d7pua">
                  {bonus.hook}
                </p>
                <p className="mt-3 flex-1 text-[14px] leading-relaxed text-white/65 sm:text-[15px]" data-id="element-94" data-mp="2jtd77wjpwv6v">
                  {bonus.body}
                </p>
                <div className="mt-4 flex flex-wrap items-center gap-x-3 gap-y-1 border-t border-white/10 pt-3" data-id="element-95" data-mp="2b09md36qtg27">
                  <span className="text-[13px] font-medium text-white/40 line-through" data-id="element-96" data-mp="261f0tthe5dee">
                    Value: {bonus.value}
                  </span>
                  <span className="text-[13px] font-extrabold uppercase tracking-[0.1em] text-teal-400" data-id="element-97" data-mp="32qmpvbh7y4n2">
                    Today: free
                  </span>
                </div>
              </div>
            </li>)}
        </ul>

        <TransformCTA headline="Get all 6 volumes + all 5 bonuses with one single payment." data-id="element-98" data-mp="2orwr7rer3wwl" />
      </div>
    </section>;
}